(() => {
  const SELECTOR = '[data-cht-header]';
  const DESKTOP_SCROLL_QUERY = window.matchMedia('(min-width: 990px)');

  const getScrollTarget = () => {
    if (DESKTOP_SCROLL_QUERY.matches) {
      return document.querySelector('.page-wrapper') || window;
    }

    return window;
  };

  const getScrollTop = (target) => {
    if (target === window) {
      return window.scrollY || document.documentElement.scrollTop || 0;
    }

    return target.scrollTop || 0;
  };

  const bindAccountAnchor = () => {
    if (window.__chtAccountAnchorBound) return;
    window.__chtAccountAnchorBound = true;

    document.addEventListener(
      'open',
      (event) => {
        const { target } = event;
        if (!(target instanceof HTMLElement) || !target.matches('shopify-account')) return;

        const bottom = Math.max(0, Math.round(target.getBoundingClientRect().bottom));
        target.style.setProperty('--account-dialog-top', `${bottom}px`);
      },
      true
    );
  };

  const initHeader = (header) => {
    if (!header || header.dataset.chtReady === 'true') return;
    header.dataset.chtReady = 'true';

    const section = header.closest('.cht-header-section');
    const stickyMode = header.dataset.sticky || 'always';
    const transparent = header.classList.contains('is-transparent');

    let scrollTarget = getScrollTarget();
    let lastY = getScrollTop(scrollTarget);
    let ticking = false;

    const syncHeaderHeight = () => {
      const shell = header.querySelector('.cht-site-header__shell');
      const height = shell?.getBoundingClientRect().height || 74;
      document.body.style.setProperty('--header-height', `${Math.round(height)}px`);
    };

    const syncHeaderGroupHeight = () => {
      const headerGroup = document.querySelector('#header-group');
      if (!(headerGroup instanceof HTMLElement)) return;

      let total = 0;

      Array.from(headerGroup.children).forEach((child) => {
        if (!(child instanceof HTMLElement)) return;

        total += child.getBoundingClientRect().height;
      });

      document.body.style.setProperty('--header-group-height', `${Math.round(total)}px`);
    };

    const setState = () => {
      const y = getScrollTop(scrollTarget);
      const scrolled = y > 60;
      const goingUp = y < lastY;

      header.classList.toggle('is-scrolled', scrolled);

      if (stickyMode === 'never') {
        header.classList.remove('is-fixed', 'is-hidden');
      } else if (stickyMode === 'always') {
        header.classList.toggle('is-fixed', scrolled);
        header.classList.remove('is-hidden');
      } else if (stickyMode === 'scroll-up') {
        if (!scrolled) {
          header.classList.remove('is-fixed', 'is-hidden');
        } else {
          header.classList.add('is-fixed');
          header.classList.toggle('is-hidden', !goingUp);
        }
      }

      section?.classList.toggle('cht-header-section--transparent', transparent && !scrolled);
      syncHeaderGroupHeight();

      lastY = y;
      ticking = false;
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(setState);
    };

    const bindScrollTarget = () => {
      scrollTarget?.removeEventListener?.('scroll', onScroll);

      scrollTarget = getScrollTarget();
      lastY = getScrollTop(scrollTarget);

      scrollTarget.addEventListener('scroll', onScroll, { passive: true });
      requestAnimationFrame(setState);
    };

    syncHeaderHeight();
    syncHeaderGroupHeight();
    bindScrollTarget();

    const headerGroup = document.querySelector('#header-group');
    let headerGroupResizeObserver;

    if (headerGroup instanceof HTMLElement && 'ResizeObserver' in window) {
      headerGroupResizeObserver = new ResizeObserver(() => {
        syncHeaderHeight();
        syncHeaderGroupHeight();
      });

      Array.from(headerGroup.children).forEach((child) => {
        if (child instanceof HTMLElement) headerGroupResizeObserver.observe(child);
      });
    }

    window.addEventListener('resize', () => {
      syncHeaderHeight();
      syncHeaderGroupHeight();
    }, { passive: true });
    DESKTOP_SCROLL_QUERY.addEventListener('change', bindScrollTarget);

    const drawer = header.querySelector('[data-cht-mobile-drawer]');
    const openButton = header.querySelector('[data-cht-mobile-open]');
    const closeButtons = header.querySelectorAll('[data-cht-mobile-close]');

    const openDrawer = () => {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cht-drawer-open');
    };

    const closeDrawer = () => {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cht-drawer-open');
    };

    openButton?.addEventListener('click', openDrawer);
    closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDrawer();
    });
  };

  const init = () => {
    bindAccountAnchor();
    document.querySelectorAll(SELECTOR).forEach(initHeader);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();